import { combineReducers } from 'redux';
import {
  CurrencyState,
  BillingState,
  CurrentOrderState,
  CustomerState,
  DesignationState,
  DetailsState,
  DiscountState,
  EmployeeState,
  ExpensesState,
  FloorState,
  InventoryState,
  ItemCategoryState,
  LabelState,
  LoginState,
  OrderItemState,
  ReceiptState,
  SalesState,
  SettingState,
  ShiftState,
  SocketState,
  TableState,
} from 'src/types/redux';
import { authReducer } from './auth.reducer';
import { currentOrderReducer } from './currentOrder.reducer';
import { customerReducer } from './customer.reducer';
import { headingReducer } from './dashLayoutHeading.reducer';
import { designationReducer } from './designation.reducer';
import { detailsReducer } from './details.reducers';
import { itemDiscountReducer } from './discount.reducers';
import { employeeReducer } from './employee.reducer';
import { expensesReducer } from './expenses.reducer';
import { floorReducer } from './floor.reducer';
import { inventoryReducer } from './inventory.reducer';
import { itemCategoryReducer } from './item.reducer';
import { itemEditReducer } from './itemEdit.reducers';
import { itemLabelReducer } from './label.reducers';
import { layoutReducer } from './layout.reducer';
import { orderItemReducer } from './orderItems.reducer';
import { receiptReducer } from './receipt.reducer';
import { salesReducer } from './sales.reducer';
import { settingReducer } from './setting.reducer';
import { shiftReducer } from './shift.reducer';
import { socketReducer } from './socket.reducer';
import { tableReducer } from './table.reducer';
import { currencyReducer } from './currency.reducer';
import { billingReducer } from './billing.reducer';

export interface RootState {
  itemCategory: ItemCategoryState;
  itemDiscount: DiscountState;
  itemLabel: LabelState;
  authReducer: LoginState;
  layoutSetting: any;
  employeeData: EmployeeState;
  expensesData: ExpensesState;
  designationData: DesignationState;
  customerData: CustomerState;
  inventoryData: InventoryState;
  floorData: FloorState;
  tableData: TableState;
  settingData: SettingState;
  billingData: BillingState;
  socketData: SocketState;
  itemEditData: any;
  detailsData: DetailsState;
  currencyData: CurrencyState;
  receiptData: ReceiptState;
  salesData: SalesState;
  shiftData: ShiftState;
  orderItemsData: OrderItemState;
  currentOrderData: CurrentOrderState;
  dashLayoutHeading: any;
}

const rootReducers = combineReducers<RootState>({
  authReducer: authReducer,
  layoutSetting: layoutReducer,
  itemCategory: itemCategoryReducer,
  itemDiscount: itemDiscountReducer,
  itemLabel: itemLabelReducer,
  employeeData: employeeReducer,
  expensesData: expensesReducer,
  designationData: designationReducer,
  customerData: customerReducer,
  inventoryData: inventoryReducer,
  socketData: socketReducer,
  floorData: floorReducer,
  tableData: tableReducer,
  settingData: settingReducer,
  billingData: billingReducer,
  itemEditData: itemEditReducer,
  detailsData: detailsReducer,
  currencyData: currencyReducer,
  receiptData: receiptReducer,
  salesData: salesReducer,
  shiftData: shiftReducer,
  orderItemsData: orderItemReducer,
  currentOrderData: currentOrderReducer,
  dashLayoutHeading: headingReducer,
});
export default rootReducers;
